module.exports = __webpack_public_path__ + "media/1alB-r-ret.ff35cd34.mp3";